import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import { extend, localize } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import * as Rules from 'vee-validate/dist/rules'
import "./vee-validate";
import i18n from './i18n';
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'

// Vee validate
for (var rule in Rules) {
  extend(rule, Rules[rule])
}
localize("en", es);

Vue.use(VueMaterial);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
